<template>
  <CustomSelect
    class="w-100"
    inputId="weekAgoTypePicker"
    inputLabel="نمایش جلسات برای"
    v-model="selectedWeekAgo"
    :value="value"
    @input="$emit('input', $event)"
    :customOptions="weekAgoOptions"
  ></CustomSelect>
</template>

<script>
export default {
  props: {
    defaultSelectedWeekAgo: {
      type: [String, Number],
      required: false,
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  mounted() {
    if (this.defaultSelectedWeekAgo) {
      this.selectedWeekAgo = this.defaultSelectedWeekAgo;
    }
  },
  data() {
    return {
      selectedWeekAgo: 0,
      weekAgoOptions: [
        {
          text: "هفته جاری",
          value: 0,
        },
        {
          text: "یک هفته پیش",
          value: 1,
        },
        {
          text: "دو هفته پیش",
          value: 2,
        },
        {
          text: "سه هفته پیش",
          value: 3,
        },
        {
          text: "چهار هفته پیش",
          value: 4,
        },
        {
          text: "پنج هفته پیش",
          value: 5,
        },
        {
          text: "شش هفته پیش",
          value: 6,
        },
        {
          text: "هفت هفته پیش",
          value: 7,
        },
        {
          text: "هشت هفته پیش",
          value: 8,
        },
      ],
    };
  },
  components: {
    CustomSelect,
  },
};
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
</script>
